import qs from 'qs';
import { useInfiniteQuery } from '@tanstack/react-query';
import axiosInstanceQueries from '../queriesAxios';
import { InspectionStatuses, InspectionSettings } from 'types';

export type InspectionOwnership = 'owned' | 'shared' | 'all';

export interface InspectionListItem {
  id: string;
  name: string;
  status: InspectionStatuses;
  userId: string;
  updatedAt: string;
  lastJobId: string | null;
  settings: InspectionSettings | null;
  isShared: boolean;
  linkedCount: number;
}

export interface InspectionListPage {
  items: InspectionListItem[];
  nextCursor: string | null;
}

export interface UseInspectionsInfiniteParams {
  ownership: InspectionOwnership;
  search?: string;
  pageSize?: number;
  enabled?: boolean;
}

const DEFAULT_PAGE_SIZE = 10;

export const inspectionsListRootKey = ['inspections', 'list'] as const;

export const useInspectionsInfinite = ({
  ownership,
  search = '',
  pageSize = DEFAULT_PAGE_SIZE,
  enabled = true,
}: UseInspectionsInfiniteParams) =>
  useInfiniteQuery({
    queryKey: [...inspectionsListRootKey, { ownership, search, pageSize }] as const,
    queryFn: async ({ pageParam }) => {
      const query = qs.stringify(
        { ownership, search: search || undefined, cursor: pageParam || undefined, limit: pageSize },
        { skipNulls: true },
      );
      const { data } = await axiosInstanceQueries.get<InspectionListPage>(`/inspections/list?${query}`);
      return data;
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled,
    staleTime: 1000 * 30,
  });
